import React from 'react';
import { getPortfolioItem } from "../../api/portfolio/PortfolioData";

import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import ButtonDefault from "../../components/button/button-default/ButtonDefault";
import BoxImageVertical from "../../components/box-image-vertical/BoxImageVertical";
import { Container } from "react-bootstrap";
import FadeUpTrigger from "../../animation/FadeUpTrigger";
import TextTrigger from "../../animation/TextTrigger";
import DsnGrid from "../../components/DsnGrid";
//--> Component
import HeaderHalf from "../../components/header/HeaderHalf";
import TitleCover from "../../components/heading/title-cover/TitleCover";
import ButtonProject from "../../components/button/button-project/ButtonProject";
import NextProject from "../../components/next/NextProject";
import BoxRight from "../../components/box-right/BoxRight";
import ParallaxImage from "../../components/parallax-image/ParallaxImage";
import { Helmet } from "react-helmet-async";


const BeaconMedical = ({ data }) => {

    const nextData = getPortfolioItem(8);


    return (
        <React.Fragment>
            <Helmet>
                <title>Devlift - {data.title} </title>
                <link rel='canonical' href='/portolio/beacon-medical' />
                <meta
                    name="description"
                    content={data.description}
                />
            </Helmet>
            {/*Start Header Half*/}
            <HeaderHalf heroContent={data}
                href="#"
                overlay={data.overlay}>
                {/* <strong className="color-heading">Published </strong> <span> - July 15th 2019 </span> */}
            </HeaderHalf>
            {/*End Header Half*/}

            {/*Start Info Project*/}
            <Container className="section-margin">
                <TitleCover>The Ask</TitleCover>
                <TextTrigger duration={0.8} stagger={0.1}>
                    {(ref) => <h2 className="title-section" ref={ref}>The Ask</h2>}
                </TextTrigger>
                <FadeUpTrigger>
                    <p className="mt-20">
                        Beacon Medical prides itself on providing a premium range of cannabinoid-based therapies but their website lacked updated functionality and desired messaging and content. With a mission to better align the website with their brand and target audience, Beacon Medical engaged Devlift for help.  The primary goals were to clearly communicate the brand story, the product offering and to help drive better user experience and retention across their client base.
                    </p>
                    <p className="mt-20">
                        Secondarily, Beacon Medical also faced the challenge of poor search engine optimization, as their website routinely had poor SEO search results for most common keyword searches.
                    </p>
                </FadeUpTrigger>
            </Container>
            {/*End Info Project*/}

            <ParallaxImage src="/assets/img/project/beacon/header.png" heightMobile="50vh" heightTable="100vh" overlay={0} />


            {/*Start Grid Project*/}
            <Container className="section-margin">
                <DsnGrid col={1} colGap={50} rowGap={50} colGapTablet={30} rowGapTablet={30}>
                    <img src="/assets/img/project/beacon/banner6.png" alt="" />
                </DsnGrid>
            </Container>
            {/*Start Grid Project*/}



            {/*Start Box Info With Image*/}
            <BoxImageVertical src="/assets/img/project/beacon/banner2.png" className="section-margin">
                <FadeUpTrigger>
                    {(ref) => <DsnGrid col={1} rowGap={30} rowGapTablet={20}>
                        <TitleCover>The Solution</TitleCover>
                        <h2 className="title-section border-line-left" ref={ref}>
                            The Solution
                        </h2>
                        <p ref={ref}>
                            In partnership with Beacon Medical, Devlift was able to deliver a digital solution to help educate customers on products and the benefits of medical cannabis, while driving increased registration and retention for users.
                        </p>
                        <p ref={ref}>
                            The team also ensured that the Beacon Medical website was fully responsive across all browsers and on mobile devices, so users could access and purchase products from anywhere.
                        </p>
                        <p ref={ref}>
                            As part of the website redesign, Beacon Medical wanted to have the capability of a backend content management system. Devlift delivered a Wordpress CMS solution and provided training to allow Beacon Medical to make full page updates quickly and easily, as their solutions and client base grow.
                        </p>
                        {/* <div className="button-box" ref={ref}>
                            <ButtonDefault text="launch" icon={faAngleRight} href="#0"/>
                        </div> */}

                    </DsnGrid>}
                </FadeUpTrigger>
            </BoxImageVertical>

            <Container className="section-margin">
                <DsnGrid col={1} colGap={50} rowGap={50} colGapTablet={30} rowGapTablet={30}>
                    <img src="/assets/img/project/beacon/banner7.png" alt="" />
                </DsnGrid>
            </Container>


            <NextProject heroContent={nextData} overlay={nextData.overlay} />


        </React.Fragment>
    );
}


export default BeaconMedical;